module.exports = __webpack_public_path__ + "img/traffic-sign.8b45eb6d.svg";